import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// Palette variables (:root / [data-theme="dark"]) - brand colors are overridden
// per-project from REACT_APP_COLOR_* in ThemeModeContext.
import "./styles/colors.module.css";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// To measure performance, pass a function to log results
// (for example: reportWebVitals(console.log)) or send to an analytics endpoint.
reportWebVitals();
